module.exports = __webpack_public_path__ + "static/media/pin-active.98e8b0c6.svg";